export class InteractionPermissionConstants {
  public static readonly READ_INTERACTION = "readInteraction";

  public static readonly MANAGE_INTERACTION = "manageInteraction";
}
